import z from 'zod';

export const cardholderSchema = z
  .object({
    donationAmount: z.number().nonnegative('Contribution amount must be positive'),
    donationType: z.string(),
    donationCurrency: z.string(),
    tip: z.number().optional(),
    sponsor_magazine: z.number().optional(),
    paymentMethod: z.enum(['debit_credit', 'manual_payment']),
  })
  .superRefine((data, ctx) => {
    console.log('data', data);
    if (data.paymentMethod === 'debit_credit') {
      if (data.donationAmount > 1000000) {
        ctx.addIssue({
          code: z.ZodIssueCode.too_big,
          type: 'number',
          maximum: 1000000,
          inclusive: true,
          path: ['donationAmount'],
          message: 'Donation amount must be less than or equal to 1,000,000',
        });
      }
    }
  });
